import type { StructureModalTabId } from "./admin-structure-modal-tabs.config";
import { STRUCTURE_GENERAL_DATA_FORM_ID } from "./adminStructureGeneralDataForm.context.definition";

export const STRUCTURE_GEOMETRY_FORM_ID = "admin-structure-geometry-form";
export const STRUCTURE_HYDROLOGY_FORM_ID = "admin-structure-hydrology-form";
export const STRUCTURE_RISK_MAPPING_FORM_ID = "admin-structure-risk-mapping-form";
export const STRUCTURE_ANM_CLASSIFICATION_FORM_ID = "admin-structure-anm-classification-form";
export const STRUCTURE_REGIONAL_CLASSIFICATION_FORM_ID =
  "admin-structure-regional-classification-form";

export { STRUCTURE_GENERAL_DATA_FORM_ID };

export const formIdForStructureModalTab = (
  tab: StructureModalTabId,
): string | null => {
  switch (tab) {
    case "generalData":
      return STRUCTURE_GENERAL_DATA_FORM_ID;
    case "geometryDam":
    case "geometry":
      return STRUCTURE_GEOMETRY_FORM_ID;
    case "hydrology":
      return STRUCTURE_HYDROLOGY_FORM_ID;
    case "riskMapping":
      return STRUCTURE_RISK_MAPPING_FORM_ID;
    case "anmClassification":
      return STRUCTURE_ANM_CLASSIFICATION_FORM_ID;
    case "regionalClassification":
      return STRUCTURE_REGIONAL_CLASSIFICATION_FORM_ID;
    default:
      return null;
  }
};
